// extracted by mini-css-extract-plugin
module.exports = {"wrappercookies":"stylecookies_wrappercookies__1AsQK"};